import React, { useState, useCallback } from 'react';

import { notification, Tabs, Divider } from 'antd';
import cep from 'cep-promise';
import * as Yup from 'yup';

import especialidades from '../../data/especialidades.json';
import Checkbox from '../Form/CheckboxControlled';
import Input from '../Form/Input';
import Textarea from '../Form/Textarea';
import ModalForm from '../Modal/ModalForm';

export default function Modal({ onClose, titleFirstTab, ...props }) {
  const [data, setData] = useState(null);
  const [especialidade, setEspecialidade] = useState([]);
  const [especialidadeOficial, setEspecialidadeOficial] = useState([]);
  const [curriculoFile, setCurriculoFile] = useState();

  const handleSetFieldValue = useCallback((_formRef, d) => {
    setEspecialidade(d.especialidade);
    setEspecialidadeOficial(d.especialidade_oficial);
    setCurriculoFile(d.curriculoFile ? d.curriculo_file_url : null);
  }, []);

  const handleAddressByCep = useCallback((e) => {
    const { value } = e.target;
    const loadAddressByCep = async () => {
      try {
        const res = await cep(value);
        setData({
          endereco: res.street,
          bairro: res.neighborhood,
          cidade: res.city,
          estado: res.state,
        });
      } catch (error) {
        // console.log(error);
      }
    };

    loadAddressByCep();
  }, []);

  const handleEspecialidade = useCallback((event) => {
    const { value, checked } = event.target;
    if (checked) {
      if (especialidade.length >= 3) {
        notification.warn({
          message: 'Aviso!!!',
          description: 'Escolha no máximo 3 atuações',
        });
        return;
      }
    }
    const parsedValue = parseInt(value, 10);
    if (checked && !especialidade.includes(parsedValue)) {
      setEspecialidade([parsedValue, ...especialidade]);
      return;
    }

    setEspecialidade(especialidade.filter((id) => id !== parsedValue));
  }, [especialidade]);

  const handleEspecialidadeOficial = useCallback((event) => {
    const { value, checked } = event.target;
    if (checked) {
      if (especialidadeOficial.length >= 3) {
        notification.warn({
          message: 'Aviso!!!',
          description: 'Escolha no máximo 3 especialidades',
        });
        return;
      }
    }
    const parsedValue = parseInt(value, 10);
    if (checked && !especialidadeOficial.includes(parsedValue)) {
      setEspecialidadeOficial([parsedValue, ...especialidadeOficial]);
      return;
    }

    setEspecialidadeOficial(especialidadeOficial.filter((id) => id !== parsedValue));
  }, [especialidadeOficial]);

  const handleSchemaValidation = async (d) => {
    if (!especialidade.length) {
      notification.warn({
        message: 'Aviso!!!',
        description: 'Escolha uma Atuação',
      });
    }

    const schemaValidation = Yup.object().shape({
      // thumbnail: Yup.mixed().required('Selecione uma imagem'),
      nome: Yup.string().required('O nome é obrigatório'),
      oab: Yup.string().required('O número da inscrição oab é obrigatório'),
      cpf: Yup.string().required('O CPF é obrigatório'),
      rg: Yup.string().required('O RG é obrigatório'),
      // cep: Yup.string().required('O CEP é obrigatório'),
      email: Yup.string()
        .email('Informe um email válido')
        .required('O email é obrigatório'),
      especialidade: Yup.mixed().test({
        name: 'especialidade',
        test: () => especialidade.length,
      }),
    });

    const validate = await schemaValidation.validate(d, {
      abortEarly: false,
    });
    return validate;
  };

  const handleFormData = useCallback(
    (d) => ({
      nome: d.nome,
      oab: d.oab,
      cpf: d.cpf,
      rg: d.rg,
      email: d.email,
      password: d.password,
      site: d.site,
      whatsapp: d.whatsapp.replace(/[^\d]+/g, ''),
      telefones: d.telefones,
      especialidade,
      especialidade_oficial: especialidadeOficial,
      facebook: d.facebook,
      instagram: d.instagram,
      descricao: d.descricao,
      cep: d.cep,
      endereco: d.endereco,
      numero: d.numero,
      bairro: d.bairro,
      cidade: d.cidade,
      estado: d.estado,
      complemento: d.complemento,
      curriculo: curriculoFile,
    }),
    [especialidade, especialidadeOficial, curriculoFile],
  );

  return (
    <ModalForm
      title="Advogado"
      addData={data}
      onFormData={handleFormData}
      onSetFieldValue={handleSetFieldValue}
      onSchemaValidation={handleSchemaValidation}
      onClose={
        onClose
          ? () => {
            setEspecialidade([]);
            onClose();
          }
          : null
      }
      {...props}
    >
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab={titleFirstTab} key="1" forceRender>
          <Input name="nome" placeholder="Nome" />
          <Input name="oab" placeholder="Número da inscrição OAB" />
          <Input name="cpf" placeholder="CPF" />
          <Input name="rg" placeholder="RG" />
          <Input name="email" placeholder="Email" />
          <Input name="whatsapp" placeholder="WhatsApp" />
          <Input name="telefones" placeholder="Outros Telefones" />
          <Input name="site" placeholder="Site" />
          <Input name="facebook" placeholder="Facebook" />
          <Input name="instagram" placeholder="Instagram" />
          <Textarea name="descricao" placeholder="Breve Descrição" rows={4} />
          <Divider />
          {curriculoFile ? (
            <p>
              <a href={curriculoFile} target="_blank" rel="noopener noreferrer">
                Currículo PDF
              </a>
            </p>
          ) : (
            <>
              <p>Selecione um arquivo PDF do currículo</p>
              <input
                type="file"
                placeholder="Arquivo do Currículo"
                accept="application/pdf"
                onChange={(e) => setCurriculoFile(e.target.files[0])}
              />
            </>
          )}
          <Divider />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Atuações" key="2" forceRender>
          {especialidades.map((e) => (
            <Checkbox
              key={e.id}
              name={`especialidade-${e.id}`}
              value={e.id}
              label={e.nome}
              checked={especialidade.includes(e.id)}
              onChange={handleEspecialidade}
            />
          ))}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Especialidades" key="3" forceRender>
          {especialidades.map((e) => (
            <Checkbox
              key={e.id}
              name={`especialidade-oficial-${e.id}`}
              value={e.id}
              label={e.nome}
              checked={especialidadeOficial.includes(e.id)}
              onChange={handleEspecialidadeOficial}
            />
          ))}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Endereço do Escritório" key="4" forceRender>
          <Input name="cep" placeholder="CEP" onChange={handleAddressByCep} />
          <Input name="endereco" placeholder="Endereço" />
          <Input name="numero" placeholder="Número" />
          <Input name="bairro" placeholder="Bairro" />
          <Input name="cidade" placeholder="Cidade" />
          <Input name="estado" placeholder="Estado" />
          <Input name="complemento" placeholder="Complemento" />
        </Tabs.TabPane>
      </Tabs>
    </ModalForm>
  );
}
